<div class="front-page">
  <img
    class="front-img no-show-preview"
    height="1225px"
    [src]="'didriksons/_lithium/gung-pim/images/comment/1637090670498_print.jpg' | gungImageUrl
      :'type:thumbnail'
    "
  />
  <img
    class="front-img no-print show-image-front"
    [src]="'didriksons/_lithium/gung-pim/images/comment/1637090670498_print.jpg' | gungImageUrl
      :'type:thumbnail'
    "
  />
</div>

<!-- Backdrop -->
<div
  class="offcanvas-backdrop fade"
  [class.show]="sidenavOptions.open"
  *ngIf="sidenavOptions.open"
  (click)="toggleSidenav()"
></div>

<!-- Sidenav -->
<div
  class="offcanvas offcanvas-start whiteboard-sidenav no-print"
  [class.show]="sidenavOptions.open"
  [class.position-fixed]="sidenavOptions.fixed"
  [style.top.px]="sidenavOptions.fixed ? (navbarConfigService.hideNavbar ? 0 : sidenavOptions.top) : null"
  [style.bottom.px]="sidenavOptions.fixed ? sidenavOptions.bottom : null"
>
  <div class="sidenav-close-row">
    <button type="button" class="btn-close sidenav-close-btn" (click)="toggleSidenav()"></button>
  </div>
  <lib-gung-accordion class="mt-4">
    <lib-gung-accordion-item [collapsed]="false">
      <ng-template libGungAccordionHeader><span translate>ACTIONS</span></ng-template>
      <ng-template libGungAccordionBody>
        <lib-whiteboard-actions></lib-whiteboard-actions>
      </ng-template>
    </lib-gung-accordion-item>

    <lib-gung-accordion-item [collapsed]="false">
      <ng-template libGungAccordionHeader><span translate>OPTIONS</span></ng-template>
      <ng-template libGungAccordionBody>
        <lib-whiteboard-options></lib-whiteboard-options>
      </ng-template>
    </lib-gung-accordion-item>

    <lib-gung-accordion-item>
      <ng-template libGungAccordionHeader><span translate>PRODUCTS</span></ng-template>
      <ng-template libGungAccordionBody>
        <lib-whiteboard-product-list></lib-whiteboard-product-list>
      </ng-template>
    </lib-gung-accordion-item>
  </lib-gung-accordion>
</div>

<button type="button" class="btn drawer-button no-print" (click)="toggleSidenav()">
  <i class="fas fa-bars"></i>
</button>

<div class="print-page">
  <!-- Main content -->
  <div role="main">
    <nav ngbNav #nav="ngbNav" class="nav-tab no-print">
      <ng-container [ngbNavItem]="i" *ngFor="let sheet of configService.sheets; let i = index">
        <a ngbNavLink translate (click)="configService.currentSheetIndex = i">
          {{ 'Sheet' }} {{ i + 1 }}
          <span
            class="close position-relative pl-2 font-weight-light"
            *ngIf="!(i == 0 && configService.sheets.length == 1)"
            (click)="
              $event.preventDefault();
              $event.stopImmediatePropagation();
              configService.removeSheet(i);
              nav.select(configService.currentSheetIndex)
            "
            >×</span
          >
        </a>
        <ng-template ngbNavContent>
          <div style="height: calc(90vh)" id="gridster-div" [style.height.px]="scrollHeight">
            <gridster [options]="configService.getGridOptions()" style="background: #ffffff">
              <gridster-item [item]="item" *ngFor="let item of sheet.items">
                <div class="remove-button">
                  <!-- The reason for the (mousedown) can be read about here: https://github.com/tiberiuzuld/angular-gridster2/issues/516 -->
                  <i
                    class="far fa-minus-square"
                    (mousedown)="$event.preventDefault(); $event.stopPropagation()"
                    (click)="removeItem(item)"
                  ></i>
                </div>
                <div *ngIf="this.products && this.products[item.productId]">
                  <div class="img-fluid">
                    <img
                      draggable="false"
                      [src]="products[item.productId].extra.images[0].s3Uri | gungImageUrl
                        :'type:thumbnail'
                        :'etag:'+products[item.productId].extra.images[0].s3ETag
                        :'size:800x1100'
                      "
                      alt="{{ products[item.productId].extra.images[0].description }}"
                      class="img-fluid"
                    />
                  </div>
                  <div class="widget-product-text mt-1">
                    <div class="row text-muted small text-left">
                      <ng-container *ngFor="let option of this.whiteboardOptionsService.options">
                        <div class="col-12 mr-auto" *ngIf="option.value">
                          <span class="badge bg-light text-dark">{{ products[item.productId][option.path] }}</span>
                        </div>
                      </ng-container>
                    </div>
                  </div>
                </div>
              </gridster-item>
            </gridster>
          </div>
        </ng-template>
      </ng-container>
      <ng-container class="nav-item">
        <a class="nav-link" (click)="$event.preventDefault(); configService.createNewSheet()">...</a>
      </ng-container>
      <ng-container class="nav-item" class="ml-auto">
        <a class="nav-link ml-auto" (click)="$event.preventDefault(); printWhiteboard('gridster-div')"
          ><span translate>PRINT</span><i class="fas fa-print ml-1"></i
        ></a>
      </ng-container>
    </nav>
    <div [ngbNavOutlet]="nav"></div>
  </div>
</div>
